import { Validators } from '@angular/forms';

export const AMAZON_SELLER_ID_MIN_LENGTH = 10;

export function amazonSellerIdValidators() {
    return [Validators.required, Validators.minLength(AMAZON_SELLER_ID_MIN_LENGTH)];
}

export const SHOP_URL_PATTERN = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

export function shopUrlValidators() {
    return [Validators.required, Validators.pattern(SHOP_URL_PATTERN)];
}

export function parseWarehouses(warehouses: any): any[] {
    if (!warehouses) {
        return [];
    }
    let parsed = warehouses;
    try {
        if (typeof parsed === 'string') {
            parsed = JSON.parse(parsed);
        }
        if (typeof parsed === 'string') {
            parsed = JSON.parse(parsed);
        }
    } catch {
        return [];
    }
    return Array.isArray(parsed) ? parsed : [];
}

export function getFilledWarehouses(warehouses: any): any[] {
    return parseWarehouses(warehouses).filter((w) =>
        w?.warehouseCountries || w?.marketplaceCountries ||
        w?.warehouseName || w?.warehouseCity || w?.warehouseAddress
    );
}

export function stringifyWarehouses(warehouses: any): string | any[] {
    if (!warehouses) {
        return [];
    }
    if (typeof warehouses === 'string') {
        return warehouses;
    }
    return JSON.stringify(warehouses);
}

export function toNumericId(value: any): number | undefined {
    if (value == null || value === '') {
        return undefined;
    }
    const id = Number(value);
    return Number.isNaN(id) ? undefined : id;
}

export function getShopList(shops: any): any[] {
    const raw = Array.isArray(shops) ? shops : shops?.marketplaces;
    if (!Array.isArray(raw)) {
        return [];
    }
    return raw.filter((shop) => shop && (shop.id || shop.shopName));
}

export function prepareShopsForSave(shops: any[], companyId?: number): any[] {
    return (shops || []).filter((shop) => shop?.shopName).map((shop) => {
        const prepared: any = { ...shop };
        const shopId = toNumericId(prepared.id);
        if (shopId) {
            prepared.id = shopId;
        } else {
            delete prepared.id;
        }
        const resolvedCompanyId = toNumericId(prepared.companyId) ?? toNumericId(companyId);
        if (resolvedCompanyId) {
            prepared.companyId = resolvedCompanyId;
        }
        const marketplaceId = toNumericId(prepared.marketplaceId);
        if (marketplaceId) {
            prepared.marketplaceId = marketplaceId;
        }
        if (prepared.amazonServiceType === '') {
            prepared.amazonServiceType = null;
        }
        if (prepared.useLocalInventory === '') {
            prepared.useLocalInventory = null;
        }
        const filledWarehouses = getFilledWarehouses(prepared.warehouses);
        prepared.warehouses = filledWarehouses.length ? stringifyWarehouses(filledWarehouses) : [];
        delete prepared.createdAt;
        delete prepared.updatedAt;
        delete prepared.deletedAt;
        delete prepared.marketplaceInfo;
        delete prepared.countries;
        delete prepared.sourceCountry;
        delete prepared.companyMarketplacePayment;
        return prepared;
    });
}
